export const V1_REQUEST_AIRPORTS = 'V1_REQUEST_AIRPORTS'

export default () => {
  return {
    type: V1_REQUEST_AIRPORTS,
  }
}
